import { useEffect, useState } from "react";

export default function AppGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const [devToolsOpen, setDevToolsOpen] =
    useState(false);

  useEffect(() => {
    const disableKeys = (
      e: KeyboardEvent
    ) => {
      const key = e.key.toUpperCase();

     const blocked =
  key === "F12" ||
  (e.ctrlKey &&
    e.shiftKey &&
    (
      key === "I" ||
      key === "J" ||
      key === "C"
    )) ||
  (e.ctrlKey && key === "U");

      if (blocked) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const disableContextMenu = (
      e: MouseEvent
    ) => {
      e.preventDefault();
    };

    document.addEventListener(
      "keydown",
      disableKeys
    );

    document.addEventListener(
      "contextmenu",
      disableContextMenu
    );

    return () => {
      document.removeEventListener(
        "keydown",
        disableKeys
      );

      document.removeEventListener(
        "contextmenu",
        disableContextMenu
      );
    };
  }, []);

  useEffect(() => {
    const detectDevTools = () => {
      let detected = false;

      // Docked DevTools detection
      const threshold = 160;

      if (
        window.outerWidth -
          window.innerWidth >
          threshold ||
        window.outerHeight -
          window.innerHeight >
          threshold
      ) {
        detected = true;
      }

      // Console inspection detection
      const element = new Image();

      Object.defineProperty(
        element,
        "id",
        {
          get() {
            detected = true;
            return "";
          },
        }
      );

      console.log(element);

      // Debugger timing detection
      const start =
        performance.now();

      // eslint-disable-next-line no-debugger
debugger;

      const end =
        performance.now();

      const executionDelay =
        end - start;

      if (executionDelay > 150) {
        detected = true;
      }

      if (detected) {
        setDevToolsOpen(true);
      }
    };

    const interval =
      window.setInterval(
        detectDevTools,
        1000
      );

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (!devToolsOpen) return;

    document.body.style.overflow =
      "hidden";

    document.body.style.pointerEvents =
      "none";

    return () => {
      document.body.style.overflow =
        "";

      document.body.style.pointerEvents =
        "";
    };
  }, [devToolsOpen]);

  if (devToolsOpen) {
    return (
      <div
        className="
          fixed
          inset-0
          z-[999999]
          flex
          items-center
          justify-center
          bg-white
        "
      >
        <div className="text-center">
          <h1 className="text-3xl font-bold">
            Access Blocked
          </h1>

          <p className="mt-4">
            Developer Tools
            detected.
          </p>

          <p className="mt-2">
            Close Developer Tools
            and refresh the page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}